import { Div } from '@codesuma/baseline'
import style from './index.module.css'

// A section of the band below the grid: a header naming it, and its rows under
// it. The slide has several and they all behave alike, so the header that comes
// to rest on the top edge of the band and the paper it wears once it is there
// are written once, here. Callers put their rows in .list.
//
// Nothing folds away: the grid and every section share the one scroll, and the
// whole slide reads as a single page carried upward.
export const Section = (title: string, scroller: HTMLElement) => {
    const base = Div()
    base.addClass(style.section)

    const head = Div(title)
    head.addClass(style.sectionHead)
    base.append(head)

    const list = Div()
    list.addClass(style.sectionList)
    base.append(list)

    // The header only wants paper behind it while it is stuck under the month
    // title with the rows passing under it — see .stuck. CSS cannot ask whether
    // a sticky element has come to rest, so the band's scroll answers it: the
    // header has arrived once it sits at its own sticky offset from the band's
    // top (the title's height, see .sectionHead). No first call: the band
    // starts at the top with the header still down under the grid, which is
    // the unstuck state the class already starts in.
    const syncStuck = () => {
        const offset = parseFloat(getComputedStyle(head.el).top) || 0
        head.toggleClass(style.stuck,
            head.el.getBoundingClientRect().top <= scroller.getBoundingClientRect().top + offset)
    }
    scroller.addEventListener('scroll', syncStuck, { passive: true })

    return Object.assign(base, { list })
}
